var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"more-content"},[_vm._v(" 更多祈福 更多祈福 更多祈福 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }